module.exports = __webpack_public_path__ + "static/media/Logo.fbacf61a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo.svg
// module id = 153
// module chunks = 0